const muithomPosts = [
    {
        image: require('./images/muithom/cards/1.png'),
    },
    {
        image: require('./images/muithom/cards/2.png'),
    },
    {
        image: require('./images/muithom/cards/3.png'),
    },
    {
        image: require('./images/muithom/cards/4.png'),
    },
    {
        image: require('./images/muithom/cards/5.png'),
    },
    {
        image: require('./images/muithom/cards/6.png'),
    },
    {
        image: require('./images/muithom/cards/7.png'),
    },
    {
        image: require('./images/muithom/cards/8.png'),
    },
    {
        image: require('./images/muithom/cards/9.png'),
    },
    {
        image: require('./images/muithom/cards/10.png'),
    },
    
];
export default muithomPosts;